// NOTE: Google Map初期化時に言語を指定するため、location.hrefから取得（vue-routerではコンポーネントができる前に取得できないので）

const url = new URL(location.href)
// NOTE: Hashモードの場合/#/の分パス内のlangが一つ後ろになる
const path = url.pathname+url.hash
const lang = path.split(/[/?]/)[2] || 'ja'
export default lang
